import DateFilterType from '@/enums/DateFilterType'
import TransportationType from '@/enums/TransportationType'

export type Filter = {
	userId: string | null
	start: string | null
	end: string | null
	startTerminalId: string | null
	endTerminalId: string | null
	startLocation: string | null
	endLocation: string | null
	certificationClaimIds: string | null
	clientId: string | null
	vesselId: string | null
	product: string | null
	dossierNumber: string | null
	clientOrderReference: string | null
	vesselGroupId: string | null
	transportationType: TransportationType
	dateFilterType: DateFilterType
    desalinated: boolean | null
    historic: boolean | null
}

export default {
	namespaced: true,
	state: () => ({
		filterUpdated: 0,
		userId: null,
		start: null,
		end: null,
		dossierNumber: null,
		startTerminalId: null,
		endTerminalId: null,
		startLocation: null,
		endLocation: null,
		certificationClaimIds: null,
		vesselId: null,
		product: null,
		clientOrderReference: null,
		clientId: null,
		vesselGroupId: null,
		transportationType: TransportationType.VESSEL,
		dateFilterType: DateFilterType.BASED_ON_TERMS,
        desalinated: null,
        historic: null
	}),

	mutations: {
		setFilter(state, filters: Filter) {
			Object.assign(state, filters)
			state.filterUpdated++
		}
	},
	getters: {
		isFiltered: (state) => {
			return (
				[
					state.userId,
					state.start,
					state.end,
					state.startTerminalId,
					state.endTerminalId,
					state.startLocation,
					state.endLocation,
					state.certificationClaimIds,
					state.dossierNumber,
					state.product,
					state.clientOrderReference,
					state.clientId,
					state.vesselGroupId,
                    state.desalinated,
                    state.historic
				].filter(Boolean).length > 0
			)
		}
	},
	actions: {
		clearFilter({ commit }) {
			const nullFilter: Filter = {
				userId: null,
				start: null,
				end: null,
				startTerminalId: null,
				endTerminalId: null,
				startLocation: null,
				endLocation: null,
				certificationClaimIds: null,
				clientId: null,
				vesselGroupId: null,
				vesselId: null,
				product: null,
				clientOrderReference: null,
				dossierNumber: null,
				transportationType: TransportationType.VESSEL,
				dateFilterType: DateFilterType.BASED_ON_TERMS,
                desalinated: null,
                historic: null
			}

			commit('setFilter', nullFilter)
		}
	}
}
